import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ArAgingReport } from '../../modules/accounts-receivable/ar-aging-report.js';
import type { ArReportSearch } from '../../modules/accounts-receivable/ar-report-search.js';
import { parseArReportSearch } from '../../modules/accounts-receivable/parse-ar-report-search.js';

export const Route = createFileRoute('/accounts-receivable/')({
  validateSearch: (search: Record<string, unknown>): ArReportSearch => parseArReportSearch(search),
  component: AccountsReceivablePage,
});

// eslint-disable-next-line react-refresh/only-export-components
function AccountsReceivablePage() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  return (
    <ArAgingReport
      search={search}
      onSearchChange={(patch) =>
        void navigate({
          from: '/accounts-receivable/',
          to: '/accounts-receivable',
          search: (previous) => ({ ...previous, ...patch }),
          replace: true,
        })
      }
    />
  );
}
